import Buttons from './Button';

export default Buttons;
